<template>
  <div id="forgot-password">
    <div id="send-email">
      <h2>{{ $t('resetting_a_password') }}</h2>
      <form @submit.prevent="onSendEmail()" method="post">
        <p class="small-txt mb10">{{ $t('please_enter_your_registered_email_address') }}</p>
        <input
          type="text"
          class="mb10"
          v-model="sendEmail.email"
          :class="[$v.sendEmail.email.$error ? 'input-error' : '']"
        >
        <div v-if="sendEmailSubmitted && $v.sendEmail.email.$error">
          <p class="error-txt mb20" v-if="!$v.sendEmail.email.required">{{ $t('please_enter_your_registered_email_address') }}</p>
          <p class="error-txt mb20" v-if="$v.sendEmail.email.required && !$v.sendEmail.email.email">{{ $t('the_format_of_the_email_address_is_different') }}</p>
        </div>
        <div class="mb10">
          <p class="error-txt mb10" v-if="sendEmailSubmitted && !$v.sendEmail.email.$error">{{ errorSendEmail }}</p>
        </div>
        <button class="btn-base" type="submit" style="border: #ffa300"><a><p>{{ $t('send_email')}}</p></a></button>
      </form>
    </div>
  </div>
</template>

<script>
  import { required, email } from "vuelidate/lib/validators"
  import { Strings } from "@/js/commons/strings"
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        Strings: Strings,
        sendEmail: {
          email :''
        },
        sendEmailSubmitted: false
      }
    },
    validations: {
      sendEmail: {
        email: { required, email }
      }
    },
    computed: {
      ...mapState({
        email: state => state.auth.email,
        errorSendEmail: state => state.auth.errorSendEmail
      })
    },
    mounted() {
      this.screenTracking(this.$t('those_who_have_forgotten_PW'))
    },
    methods: {
      async onSendEmail() {
        this.sendEmailSubmitted = true
        this.$v.sendEmail.$touch()
        if (this.$v.sendEmail.$error) return
        else {
          const email = this.sendEmail.email.trim().toLowerCase()
          await this.$store.dispatch('auth/sendResetLink', { email })
          if (!this.errorSendEmail) {
            this.$store.dispatch('auth/setEmailReset', email)
            this.$router.push({ path: '/change-password' }).catch(err => {})
          }
        }
      }
    }
  }
</script>